import { Icon } from '../../../../components/icon/icon';
import './SidebarDesign.scss';
import ButtonIconMediumChangeIconColor from '../../../../components/common/ButtonIconGhost/ButtonIconMediumChangeIconColor';
import Tooltip from '../../../../components/common/Tooltip/Tooltip';
import { useContext, useEffect, useState } from 'react';
import { DesignerPageContext } from '../../DesignerPage';
import { fetchTextureType } from '../../../../store/actions/module.action';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

const SidebarDesign = ({ activeKey, setActiveKey }) => {
  const { cabinetType } = useContext(DesignerPageContext);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const wardrobe = [
    {
      tooltip: t('Frame'),
      icon: Icon.ICSpecial2,
      key: 'wr1',
    },
    {
      tooltip: t('Partition'),
      icon: Icon.ICSpecial5,
      key: 'wr2',
    },
    {
      tooltip: t('Accessories'),
      icon: Icon.ICSpecial6,
      key: 'wr3',
    },
    {
      tooltip: t('Door'),

      icon: Icon.ICSpecial3,
      key: 'wr4',
    },
    {
      tooltip: t('Handle'),
      icon: Icon.ICSpecial4,
      key: 'wr5',
    },
    {
      tooltip: t('Lighting'),
      icon: Icon.ICSpecial7,
      key: 'wr6',
    },
  ];

  const kitchen = [
    {
      tooltip: t('Kitchen Cabinet'),
      icon: Icon.ICSpecial2,
      key: 'kt1',
    },
    {
      tooltip: t('Island cabinet'),
      icon: Icon.ICKitchenIsland,
      key: 'kt2',
    },
    {
      tooltip: t('Countertop'),
      icon: Icon.ICKitchenSurface,
      key: 'kt3',
      onClick: () => {
        dispatch(fetchTextureType({ groupName: 'countertop' }));
      },
    },
    {
      tooltip: t('Backsplash'),
      icon: Icon.ICWall,
      key: 'kt4',
      onClick: () => {
        dispatch(fetchTextureType({ groupName: 'backsplash' }));
      },
    },
    {
      tooltip: t('Lighting'),
      icon: Icon.ICSpecial7,
      key: 'kt5',
      onClick: () => {
        dispatch(fetchTextureType({ groupName: 'lighting' }));
      },
    },
  ];

  const items = [
    cabinetType === 'kitchen' ? kitchen : wardrobe,
    [
      {
        tooltip: t('Space'),
        icon: Icon.ICSpecial,
        key: 'wallSetupForm',
        noActive: true,
      },
    ],
  ];

  useEffect(() => {
    setActiveKey({ key: items[0][0].key, active: false });
  }, []);

  return (
    <div className="sidebar-design">
      {items.map((item, key) => {
        return (
          <div className="container-button" key={key}>
            {item.map((btn, key2) => {
              return (
                <Tooltip title={btn.tooltip} placement="rightTop" key={key2}>
                  <ButtonIconMediumChangeIconColor
                    style={{ width: '36px', height: '36px' }}
                    icon={btn.icon}
                    onClick={() => {
                      if (btn.onClick) btn.onClick();
                      if (activeKey.key === btn.key && activeKey.active)
                        setActiveKey(prev => ({ ...prev, active: false }));
                      else setActiveKey({ key: btn.key, active: true });
                    }}
                    active={activeKey.key === btn.key && !btn.noActive}
                  />
                </Tooltip>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default SidebarDesign;
